<template>
  <section class="titled-list">
    <h3
      class="titled-list__title"
      :style="titleFirst ? 'order: 1' : 'order: 2'"
    >
      {{ title }}
    </h3>
    <ul class="titled-list__list" :style="titleFirst ? 'order: 2' : 'order: 1'">
      <li v-for="(item, i) in list" :key="`item_${i}`">
        <p>
          <span>{{ i + 1 }}.</span>
          {{ item }}
        </p>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'TitledList',
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    list: {
      type: Array,
      default: () => [],
      required: true,
    },
    titleFirst: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
}
</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;

.titled-list {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: flex-start;
  &__title {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    padding: 30px;
    margin: 0;
    @media (max-width: $tablet) {
      padding: 20px;
    }
  }
  &__list {
    list-style: none;
    padding: 20px;
    margin: 0;
    li {
      p {
        span {
          font-weight: 600;
          font-size: 22px;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>